<template>
  <div class="search-page">
    <page-header />
    <page-main />
  </div>
</template>
<script>
import PageHeader from '../search-page/views/page-header/page-header.vue'
import PageMain from './page-main/page-main.vue'
export default {
  name: 'UploadPageEducation',
  components: { PageHeader, PageMain },
  provide() {
    return { title: '继续教育', tip: '继续教育开班及换证', type: 1 }
  },
  mounted() {
    document.title = '中国检验认证集团浙江有限公司-换证继续教育'
  }
}
</script>
